import DefaultAvatarIcon from 'assets/svgs/DefaultAvatarIcon';
import RobotIcon from 'assets/svgs/RobotIcon';
import React from 'react';

import './index.styles.scss';

interface Props {
  data: any;
  onPressed: (item) => void;
}

export const MobileCardUserBot = ({ data, onPressed }: Props) => {
  const renderBotIcon = () => {
    return (
      <div className="bot_icon">
        <RobotIcon size={16} color={'white'} />
      </div>
    );
  };

  return (
    <div
      className="mobile_card_user_bot row_align_items"
      onClick={() => {
        onPressed(data);
      }}
    >
      <div style={{ position: 'relative' }}>
        {data.image && data.image.startsWith('https') ? (
          <img src={data.image} className="bot_image" />
        ) : (
          <DefaultAvatarIcon size={40} />
        )}
        {renderBotIcon()}
      </div>

      <div className="main_info">
        <div className="font-bold font16">{data.name}</div>
        <div className="bot_description font-regular font12">
          {data.description}
        </div>
      </div>
    </div>
  );
};
